import styled from "styled-components";
import { BaseModalBackground } from "styled-react-modal";
import { transparentize } from "polished";

const SpecialModalBackground = styled(BaseModalBackground as any)`
  ${({ theme }) => `
    background-color: ${transparentize(0.2, theme.colors.primaryDark)};
  `}
`;

export default SpecialModalBackground;
